import React, { useState } from "react";

// LigneOrganes — ce qui est RÉELLEMENT allumé, en une ligne repliable.
//
// POURQUOI CET ÉCRAN EXISTE. L'opérateur a des interrupteurs de trois natures
// (variables Vercel, drapeau en base, plafond de code) et aucun endroit ne
// disait leur état d'ensemble. Cas vécu : l'opérateur pouvait apprendre une
// règle sans que le copilote la reçoive jamais — et rien nulle part ne le
// montrait. C'est exactement le « défaut silencieux et plausible » : tout
// s'affiche, rien n'est faux à l'écran, et le résultat est creux.
//
// ⚠️ RÈGLE — il n'invente RIEN. Chaque valeur vient de `etat_operateur.organes`,
// dérivé côté serveur des variables d'environnement à l'instant de l'appel. Si
// le serveur ne l'envoie pas, ce composant ne s'affiche PAS : un écran qui
// devine un drapeau est pire qu'un écran absent, parce qu'il fait croire qu'on
// a regardé.

const LIBELLES = [
  ["propose", "Il prépare vos matins"],
  ["memoire_injectee", "Ce qu’il retient de vous atteint ses brouillons"],
  ["mail_ingestion", "Il relève votre boîte"],
  ["mail_lecture", "Il ouvre les courriels pour les comprendre"],
  ["envoi_reel", "Ses envois partent pour de vrai"],
];

export default function LigneOrganes({ organes }) {
  const [ouvert, setOuvert] = useState(false);
  if (!organes || typeof organes !== "object") return null;

  const allumes = LIBELLES.filter(([cle]) => organes[cle] === true).length;
  const total = LIBELLES.length;

  return (
    <div data-testid="ligne-organes" style={{ margin: "0 2px 12px" }}>
      <button
        type="button"
        data-testid="organes-bascule"
        aria-expanded={ouvert}
        onClick={() => setOuvert((v) => !v)}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          font: "inherit",
          fontSize: 11,
          color: "var(--gris)",
          textAlign: "left",
        }}
      >
        {allumes === 0
          ? "Tout est éteint"
          : `${allumes} organe${allumes > 1 ? "s" : ""} sur ${total} allumé${allumes > 1 ? "s" : ""}`}
        <span aria-hidden="true" style={{ marginLeft: 6, opacity: 0.6 }}>
          {ouvert ? "▾" : "▸"}
        </span>
      </button>

      {ouvert && (
        <ul
          data-testid="organes-liste"
          style={{
            listStyle: "none",
            margin: "7px 0 0",
            padding: 0,
            fontSize: 11.5,
          }}
        >
          {LIBELLES.map(([cle, texte]) => {
            const on = organes[cle] === true;
            return (
              <li
                key={cle}
                data-testid={`organe-${cle}`}
                data-etat={on ? "allume" : "eteint"}
                style={{
                  display: "flex",
                  gap: 8,
                  alignItems: "baseline",
                  padding: "2px 0",
                  color: on ? "var(--navy-d)" : "var(--gris)",
                }}
              >
                {/* Le mot porte l'information, jamais la couleur seule. */}
                <span
                  style={{ minWidth: 46, fontSize: 10, opacity: on ? 1 : 0.75 }}
                >
                  {on ? "allumé" : "éteint"}
                </span>
                <span>{texte}</span>
              </li>
            );
          })}
          {organes.modele ? (
            <li
              data-testid="organe-modele"
              style={{
                padding: "5px 0 0",
                color: "var(--gris)",
                fontSize: 10.5,
              }}
            >
              Le modèle qui lui parle : {organes.modele}
            </li>
          ) : null}
        </ul>
      )}
    </div>
  );
}
